<u4-cpp-iconsprite></u4-cpp-iconsprite>
<u4-cpp-loader></u4-cpp-loader>

<u4-cpp-layout *ngIf="(isReady | async)"></u4-cpp-layout>
